import { DocumentApproveDocument } from "isogd-document-rest";

class DocumentApproveViewController {
    private approveDocument: DocumentApproveDocument;
}

export const DocumentApproveViewComponent: angular.IComponentOptions = {
    controller: DocumentApproveViewController,
    template: require('./documentApproveView.html'),
    bindings: {
        approveDocument: "<"
    }
};


// WEBPACK FOOTER //
// ./src/components/document/document-approve/documentApproveView.ts